import { render, staticRenderFns } from "./MarkedUpImagesGallery.vue?vue&type=template&id=4c8bb9a6&scoped=true&"
import script from "./MarkedUpImagesGallery.vue?vue&type=script&lang=ts&"
export * from "./MarkedUpImagesGallery.vue?vue&type=script&lang=ts&"
import style0 from "./MarkedUpImagesGallery.vue?vue&type=style&index=0&id=4c8bb9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8bb9a6",
  null
  
)

export default component.exports